import { useLocation } from "react-router-dom";


const IframePage = ({url}: {url?: string}) => {
  const { state } = useLocation();
  const iframeUrl = state?.iframeUrl || url;

  if (!iframeUrl) {
    return <div className="flex items-center justify-content text-muted">No content available</div>;
  }

  return (
    <iframe
      allow="autoplay; fullscreen; picture-in-picture; encrypted-media; web-share"
      sandbox="allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
      src={iframeUrl}
      title="Embedded Content"
      width="100%"
      height="100%"
      style={{ border: "none", minHeight: "100vh" }}
    />
  );
};

export default IframePage;